import React, { useEffect, useState, useMemo } from "react";
import { Helmet } from "react-helmet";
import { apiUrl } from '../constants'
import axios from 'axios'
import CardPhoto from '../components/card/CardPhotoToUseLocation';
import { Box, Grid, Container, Tab, Tabs, Toolbar, Typography, useTheme } from "@mui/material";
import { tokens } from "../theme";
import chickenKoratImg from "../assets/img/chickenKorat.jpg"
import { useSelector } from 'react-redux';
import useCheckToken from '../hooks/useCheckToken';
import useExchangeToken from "../hooks/useExchangeToken";
import { useParams } from 'react-router-dom';
import Vietnam from '../assets/img/vietnam.jpg';

const CardPhotoMemo = React.memo(CardPhoto);

const PlantList = () => {
  const { bu } = useParams();
  const exchangeToken = useExchangeToken();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [plant, setPlant] = useState([]);
  const [isTokenExchanged, setIsTokenExchanged] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useCheckToken();
  const ac_token = useSelector(state => state.auth.access_token);
  const plant_id = useSelector((state) => state.auth.plant_id);

  function storeCourse(name) {
    localStorage.setItem('plant', name)
  }

  useEffect(() => {
    const fetchInitialTokenAndData = async () => {
      try {
        const token = await exchangeToken();
        if (token) {
          setIsTokenExchanged(true);
        }
      } catch (err) {
        console.error("Error exchanging token:", err);
        setError("Failed to exchange token");
      }
    };

    fetchInitialTokenAndData();
  }, [exchangeToken]);


  useEffect(() => {
    const fetchMyAPI = async () => {
      if (!ac_token) return; 
      setLoading(true);
      try {
        const response = await axios.get(`${apiUrl.MASTER_PLANT}${bu}`, {
          headers: {
            Authorization: `Bearer ${ac_token}`,
          },
        });

        if (response.status === 200) {
          setPlant(response.data.PLANT || [])
        }
      } catch (err) {
        setError(err.message);
        console.error("Error fetching Plant data:", err);
      } finally {
        setLoading(false);
      }
    };

    if (isTokenExchanged && ac_token) {
      fetchMyAPI();
    }
  }, [isTokenExchanged, ac_token]);

  plant.sort((a, b) => {
    if (a.length !== b.length) {
      return a.length - b.length;
    }
    return a.localeCompare(b);
  });

  // const filterBUData = (plant_id, plant_from_api) => {
  //   if (plant_id === "All") {
  //     return plant_from_api; // แสดงผลทั้งหมดถ้า bu_store เป็น 'all'
  //   } else if (plant_id === "None") {
  //     return plant_from_api;
  //   } else if (plant_id === "-") {
  //     return plant_from_api;
  //   }
  //   return plant_from_api.filter((item) => item === plant_id); // กรองเฉพาะ BU ที่ตรงกับ bu_store
  // };

  const filterBUData = (plant_id, plant_from_api) => {
    const value = (plant_id ?? "").trim().toLowerCase();

    if (
      value === "all" ||
      value === "none" ||
      value === "-"
    ) {
      return plant_from_api;
    }

    return plant_from_api.filter(
      (item) => item?.toLowerCase() === value
    );
  };

  const imageMap = {
    "4117": chickenKoratImg,
    "B425": Vietnam,
  };

  const getImageByPlant = (name) => imageMap[name] ?? chickenKoratImg;

  const plantData = useMemo(() => {
    const filteredBu = filterBUData(plant_id, plant);
    return filteredBu.length === 0
      ? []
      : filteredBu.map((name, index) => ({
          key: index,
          name,
          fileLocation: getImageByPlant(name),
        }));
  }, [plant, plant_id]);
  

  return (
    <Box style={{ width: "100%", height: "90vh" }}>
      <Helmet>
        <title>Plant | MES</title>
      </Helmet>
      {/* <Grid item xs={12} style={{paddingTop: 5, paddingLeft: 30}}>
          <Typography
            style={{ color: "#000000", fontSize: 20, lineHeight: "2vh" }}
          >
            {localStorage.getItem("buName")}
          </Typography>
      </Grid> */}
      <Grid container spacing={2}>

        <Grid item xs={12} sm={12}>
          <Box
            m='1%'
            display="grid"
            gridTemplateColumns="repeat(12, 1fr)"
            gridAutoRows={plantData.length > 6 ? "50%" : "100%"}
            columnGap="1%"
            rowGap="6%"
          >
            {/* ESTIMATED */}
            {plantData.map((item) => (
              <Box
                key={item.key || item.id}
                gridColumn="span 2"
                display="flex"
                alignItems="center"
                justifyContent="center"
                onClick={() => storeCourse(item.name)}
              >
                <CardPhotoMemo name={item.name} fileLocation={item.fileLocation || chickenKoratImg} />
              </Box>
            ))
            }
          </Box>
        </Grid>
      </Grid>
    </Box>
  )
}

export default PlantList
